import React, { createContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { signOutSuccess } from 'store/slices/authSlice';
import { setupLogoutListener, clearAllLocalStorage, clearAllSessionStorage, clearReduxState } from 'utils/logoutUtils';

// Create context
const LogoutContext = createContext();

/**
 * Provider component that sets up listeners for logout events across tabs
 * This ensures that when a user logs out in one tab, all other tabs are also logged out
 */
export const LogoutProvider = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Handle logout events from other tabs
    const handleLogout = () => {
      console.log('Logout event received from another tab');
      // Clear all localStorage items
      clearAllLocalStorage();
      // Clear all sessionStorage items
      clearAllSessionStorage();
      // Clear Redux state and RTK Query cache
      clearReduxState();
      // Update Redux state
      dispatch(signOutSuccess());
    };

    // Set up the logout listener
    const cleanup = setupLogoutListener(handleLogout);

    // Clean up the listener when the component unmounts
    return cleanup;
  }, [dispatch]);

  return (
    <LogoutContext.Provider value={{}}>
      {children}
    </LogoutContext.Provider>
  );
};

export default LogoutContext;
